import React from "react";
import { Outlet } from "react-router-dom";
import Navbar from "./navbar";
export function Layout() {
    return (
        <>
            <div className="relative h-[100vh] w-full flex flex-col md:flex-row">
                <Navbar />
                <div className="divider md:divider-horizontal !m-0" />
                <div className="w-full h-screen overflow-auto">
                    <Outlet />
                </div>
            </div>
        </>
    )
}